module.exports = __webpack_public_path__ + "img/btn_close-w.eb233ef5.svg";